export const queryKeys = {
  allFieldDetails: ['allFieldDetails'],
  allMetricData: ['allMetricData'],
  fieldById: ['fieldById'],
  allProducers: ['allProducers'],
  bankTypeEnum: ['bankTypeEnum'],
  bankFarmers: ['bankFarmers'],
  surveyList: ['surveyList'],
  surveyDetails: ['surevy-details'],
  surveyFieldDetails: ['surevy-field-details']
};

export const mutationKeys = {
  updateFieldStatus: ['updateFieldStatus'],
  submitQuestionaire: ['submit-questionaire'],
  editDocument: ['edit-document'],
  deleteDocument: ['delete-document'],
  addProducerByPartner: ['add-producer-by-partner'],
  addField: ['add-field'],
  editField: ['edit-field']
};
